import React, { useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Select from 'react-select';
import axios from 'axios';

export function Profile({ stateDetail }) {
  const [name, setName] = useState('');
  const [role, setRole] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [photo, setPhoto] = useState('');
  const [photoFile, setPhotoFile] = useState([]);
  const [oldPassword, setOldPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passConfirm, setPassConfirm] = useState('');
  const [changePass, setChangePass] = useState(false);

  const { id } = useParams();
  const history = useHistory();

  return (
    <React.Fragment>
      <div className='container flex items-center justify-center py-5'>
        <div className='w-full'>
          <div className='card p-5'>
            <form className='w-full'>
              <div className='grid grid-cols-1 gap-4'>
                <br />
                <div>
                  <label
                    className='label block mb-2'
                    style={{ color: '#145488', float: 'revert', fontSize: 24 }}
                    htmlFor='title'
                  >
                    Data Profile
                  </label>
                </div>
                <div>
                  <label className='label block mb-2' htmlFor='title'>
                    Display Name{' '}
                  </label>
                  <input
                    id='title'
                    disabled
                    type='text'
                    className='form-control'
                    value={stateDetail.name}
                    onChange={(event) => setName(event.target.value)}
                  />
                </div>
                <div>
                  <label className='label block mb-2' htmlFor='title'>
                    Email
                  </label>
                  <input
                    id='title'
                    type='text'
                    disabled
                    className='form-control bg-gray-100 cursor-not-allowed'
                    value={stateDetail.email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                </div>

                <div>
                  <label className='label block mb-2' htmlFor='title'>
                    Display Role{' '}
                  </label>
                  <input
                    id='title'
                    disabled
                    type='text'
                    className='form-control bg-gray-100 cursor-not-allowed'
                    value={stateDetail.role === 0 ? ('Customer') : 'Admin'}
                    onChange={(event) => setRole(event.target.value)}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
